module.exports = __webpack_public_path__ + "static/media/man_suit_thumb.c92772a5.webp";